var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAliexpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 5,
    y: 42,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "currentColor"
  }, "AliExpress")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliexpress);
export default __webpack_public_path__ + "static/media/aliexpress.835c46d652136a9a20c6d8a8be306a12.svg";
export { ForwardRef as ReactComponent };